<template>
  <div class="files-requests-empty-state" :data-testid="dataTestId">
    <div class="files-requests-empty-state__icon-wrap" aria-hidden="true">
      <img :src="iconSrc" alt="" class="files-requests-empty-state__icon" />
    </div>
    <p class="files-requests-empty-state__text">{{ message }}</p>
  </div>
</template>

<script>
const EMPTY_STATE_CONFIG = {
  files: {
    icon: '/img/icons/fbc-icons/UploadIcon.svg',
    message: 'No files uploaded',
  },
  requests: {
    icon: '/img/icons/fbc-icons/CircleQuestionMark.svg',
    message: 'No information requests',
  },
};

export default {
  name: 'FilesRequestsEmptyState',

  props: {
    variant: {
      type: String,
      default: 'files',
      validator: (value) => ['files', 'requests'].includes(value),
    },
    dataTestId: {
      type: String,
      default: 'files-requests-empty-state',
    },
  },

  computed: {
    config() {
      return EMPTY_STATE_CONFIG[this.variant] || EMPTY_STATE_CONFIG.files;
    },

    iconSrc() {
      return this.config.icon;
    },

    message() {
      return this.config.message;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/files-requests';

.files-requests-empty-state {
  @include files-requests-empty-state;
}

.files-requests-empty-state__icon-wrap {
  @include files-requests-empty-state__icon-wrap;
}

.files-requests-empty-state__icon {
  @include files-requests-empty-state__icon;
}

.files-requests-empty-state__text {
  @include files-requests-empty-state__text;
}
</style>
